import { useMatches } from 'react-router-dom';
import { isNil } from 'lodash/fp';

const useNavSelection = () => {
  const navSelection =
    useMatches()?.find(({ handle }: any) => !isNil(handle?.type))?.handle ??
    ({} as any);

  return navSelection.type;
};

export { useNavSelection };
